import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './rootSiteTemplatesQuery.gql';
import { RootSiteTemplateFragmentDoc } from '../../fragments/root_site_templates/RootSiteTemplateFragment.generated';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type RootSiteTemplatesQuery_rootSiteTemplates_RootSiteTemplatePaginationHandler_records_RootSiteTemplate_previewScreenshots_RootSiteTemplatePreviewScreenshot_imageUploadedPhoto_UploadedPhoto_uiUploadable_UiUploadableBase = {
  __typename: 'UiUploadableBase',
  id: number,
  isMutable: boolean,
  showDeleteOption: boolean,
  showDownloadOption: boolean,
  showMoveOption: boolean,
  showCopyOption: boolean,
  showEditOption: boolean
};

export type RootSiteTemplatesQuery_rootSiteTemplates_RootSiteTemplatePaginationHandler_records_RootSiteTemplate_previewScreenshots_RootSiteTemplatePreviewScreenshot_imageUploadedPhoto_UploadedPhoto_uiUploadable_UiUploadableUploadedPhoto = {
  __typename: 'UiUploadableUploadedPhoto',
  id: number,
  isMutable: boolean,
  showDeleteOption: boolean,
  showDownloadOption: boolean,
  showMoveOption: boolean,
  showCopyOption: boolean,
  showEditOption: boolean
};

export type RootSiteTemplatesQuery_rootSiteTemplates_RootSiteTemplatePaginationHandler_records_RootSiteTemplate_previewScreenshots_RootSiteTemplatePreviewScreenshot_imageUploadedPhoto_UploadedPhoto_uiUploadable =
  | RootSiteTemplatesQuery_rootSiteTemplates_RootSiteTemplatePaginationHandler_records_RootSiteTemplate_previewScreenshots_RootSiteTemplatePreviewScreenshot_imageUploadedPhoto_UploadedPhoto_uiUploadable_UiUploadableBase
  | RootSiteTemplatesQuery_rootSiteTemplates_RootSiteTemplatePaginationHandler_records_RootSiteTemplate_previewScreenshots_RootSiteTemplatePreviewScreenshot_imageUploadedPhoto_UploadedPhoto_uiUploadable_UiUploadableUploadedPhoto
;

export type RootSiteTemplatesQuery_rootSiteTemplates_RootSiteTemplatePaginationHandler_records_RootSiteTemplate_previewScreenshots_RootSiteTemplatePreviewScreenshot_imageUploadedPhoto_UploadedPhoto = {
  __typename: 'UploadedPhoto',
  aimAvailable: boolean,
  altText?: string | null,
  bytes: number,
  category?: string | null,
  consumerLocale?: string | null,
  createdAt: string,
  defaultType?: string | null,
  folderPath?: string | null,
  format: string,
  fullUrl: string,
  height?: number | null,
  id: number,
  isPosSynced: boolean,
  originalFilename: string,
  previewUrl: string,
  publicId?: string | null,
  rawUrl: string,
  restaurantId?: number | null,
  thumbnailUrl: string,
  updatedAt: string,
  uploaded?: boolean | null,
  uploadedFolderId?: number | null,
  url?: string | null,
  userId?: number | null,
  width?: number | null,
  uiUploadable: RootSiteTemplatesQuery_rootSiteTemplates_RootSiteTemplatePaginationHandler_records_RootSiteTemplate_previewScreenshots_RootSiteTemplatePreviewScreenshot_imageUploadedPhoto_UploadedPhoto_uiUploadable
};

export type RootSiteTemplatesQuery_rootSiteTemplates_RootSiteTemplatePaginationHandler_records_RootSiteTemplate_previewScreenshots_RootSiteTemplatePreviewScreenshot = {
  __typename: 'RootSiteTemplatePreviewScreenshot',
  id: number,
  imageUrl: string,
  position: number,
  thumbnailUrl: string,
  imageUploadedPhoto?: RootSiteTemplatesQuery_rootSiteTemplates_RootSiteTemplatePaginationHandler_records_RootSiteTemplate_previewScreenshots_RootSiteTemplatePreviewScreenshot_imageUploadedPhoto_UploadedPhoto | null
};

export type RootSiteTemplatesQuery_rootSiteTemplates_RootSiteTemplatePaginationHandler_records_RootSiteTemplate_restaurant_Restaurant = {
  __typename: 'Restaurant',
  id: number,
  name: string,
  slug?: string | null,
  popmenuUrl?: string | null
};

export type RootSiteTemplatesQuery_rootSiteTemplates_RootSiteTemplatePaginationHandler_records_RootSiteTemplate_screenshotUploadedPhoto_UploadedPhoto = {
  __typename: 'UploadedPhoto',
  aimAvailable: boolean,
  altText?: string | null,
  bytes: number,
  category?: string | null,
  consumerLocale?: string | null,
  createdAt: string,
  defaultType?: string | null,
  folderPath?: string | null,
  format: string,
  fullUrl: string,
  height?: number | null,
  id: number,
  isPosSynced: boolean,
  originalFilename: string,
  previewUrl: string,
  publicId?: string | null,
  rawUrl: string,
  restaurantId?: number | null,
  thumbnailUrl: string,
  updatedAt: string,
  uploaded?: boolean | null,
  uploadedFolderId?: number | null,
  url?: string | null,
  userId?: number | null,
  width?: number | null,
  uiUploadable: RootSiteTemplatesQuery_rootSiteTemplates_RootSiteTemplatePaginationHandler_records_RootSiteTemplate_previewScreenshots_RootSiteTemplatePreviewScreenshot_imageUploadedPhoto_UploadedPhoto_uiUploadable
};

export type RootSiteTemplatesQuery_rootSiteTemplates_RootSiteTemplatePaginationHandler_records_RootSiteTemplate = {
  __typename: 'RootSiteTemplate',
  id: number,
  createdAt?: string | null,
  description?: string | null,
  isEnabled?: boolean | null,
  isEssentialsEnabled: boolean,
  isRootAccessOnly: boolean,
  isThemeTemplate?: boolean | null,
  name: string,
  position?: number | null,
  restaurantId: number,
  screenshotUrl?: string | null,
  previewScreenshots: Array<RootSiteTemplatesQuery_rootSiteTemplates_RootSiteTemplatePaginationHandler_records_RootSiteTemplate_previewScreenshots_RootSiteTemplatePreviewScreenshot>,
  restaurant?: RootSiteTemplatesQuery_rootSiteTemplates_RootSiteTemplatePaginationHandler_records_RootSiteTemplate_restaurant_Restaurant | null,
  screenshotUploadedPhoto?: RootSiteTemplatesQuery_rootSiteTemplates_RootSiteTemplatePaginationHandler_records_RootSiteTemplate_screenshotUploadedPhoto_UploadedPhoto | null
};

export type RootSiteTemplatesQuery_rootSiteTemplates_RootSiteTemplatePaginationHandler = {
  __typename: 'RootSiteTemplatePaginationHandler',
  count: number,
  hasMore: boolean,
  offset: number,
  records: Array<RootSiteTemplatesQuery_rootSiteTemplates_RootSiteTemplatePaginationHandler_records_RootSiteTemplate>
};

export type RootSiteTemplatesQuery_Query = {
  __typename?: 'Query',
  rootSiteTemplates: RootSiteTemplatesQuery_rootSiteTemplates_RootSiteTemplatePaginationHandler
};


export type RootSiteTemplatesQueryVariables = Types.Exact<{
  isOnboardingTemplate?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
  templateType?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type RootSiteTemplatesQuery = RootSiteTemplatesQuery_Query;


export const RootSiteTemplatesDocument = /*#__PURE__*/ document as unknown as DocumentNode<RootSiteTemplatesQuery, RootSiteTemplatesQueryVariables>;


/**
 * __useRootSiteTemplatesQuery__
 *
 * To run a query within a React component, call `useRootSiteTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRootSiteTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRootSiteTemplatesQuery({
 *   variables: {
 *      isOnboardingTemplate: // value for 'isOnboardingTemplate'
 *      pagination: // value for 'pagination'
 *      templateType: // value for 'templateType'
 *   },
 * });
 */
export function useRootSiteTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RootSiteTemplatesQuery, RootSiteTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RootSiteTemplatesQuery, RootSiteTemplatesQueryVariables>(RootSiteTemplatesDocument, options);
      }
export function useRootSiteTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RootSiteTemplatesQuery, RootSiteTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RootSiteTemplatesQuery, RootSiteTemplatesQueryVariables>(RootSiteTemplatesDocument, options);
        }
// @ts-ignore
export function useRootSiteTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RootSiteTemplatesQuery, RootSiteTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RootSiteTemplatesQuery, RootSiteTemplatesQueryVariables>;
export function useRootSiteTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RootSiteTemplatesQuery, RootSiteTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RootSiteTemplatesQuery | undefined, RootSiteTemplatesQueryVariables>;
export function useRootSiteTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RootSiteTemplatesQuery, RootSiteTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RootSiteTemplatesQuery, RootSiteTemplatesQueryVariables>(RootSiteTemplatesDocument, options);
        }
export type RootSiteTemplatesQueryHookResult = ReturnType<typeof useRootSiteTemplatesQuery>;
export type RootSiteTemplatesLazyQueryHookResult = ReturnType<typeof useRootSiteTemplatesLazyQuery>;
export type RootSiteTemplatesSuspenseQueryHookResult = ReturnType<typeof useRootSiteTemplatesSuspenseQuery>;
export type RootSiteTemplatesQueryResult = ApolloReactCommon.QueryResult<RootSiteTemplatesQuery, RootSiteTemplatesQueryVariables>;